import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const AllSchoolPricing = () => {
  const [allSchoolPricing, setAllSchoolPricing] = useState([]);
  const [schoolClassName, setSchoolClassName] = useState([]);
  const [classId, setClassId] = useState();

  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();

  const handleAddPrice = () => {
    navigate("/exam-notes-pricing/add-school-pricing");
  };
  const handleViewAllPrice = () => {
    navigate("/exam-notes-pricing/all-school-pricing");
  };

  const getClasses = () => {
    axios
      .get(`${API_BASE_URL}/classes`)
      .then((resp) => {
        const { data } = resp.data;
        setSchoolClassName(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getClasses();
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    axios
      .get(`${API_BASE_URL}/pricing/exam-notes?classId=${classId}`)
      .then((result) => {
        console.log(result);
        const { data } = result.data;
        setAllSchoolPricing(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleEdit = (id) => {
    navigate(`/exam-notes-pricing/edit-school-pricing/${id}`);
  };
  const handleDelete = (id) => {
    const confirm = window.confirm("Are you sure you want to delete pricing.");
    if (confirm) {
      axios
        .delete(`${API_BASE_URL}/admin/pricing/exam-notes/${id}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then((response) => {
          console.log(response);
          alert("Price deleted successfully.");
        })
        .catch((error) => {
          console.log(error);
          alert("Error while deleting.");
        });
    }
  };

  return (
    <div id="classes-inner-wrapper">
      <div className="classes-header-div">
        <h5>All Exam Notes School Pricing</h5>
        <div className="classes-header-btns">
          <button className="add-class-btn" onClick={handleAddPrice}>
            + Add Price
          </button>
          <button className="all-classes-btn" onClick={handleViewAllPrice}>
            All Price
          </button>
        </div>
      </div>

      <form onSubmit={handleSearch} className="department-detail-form p-3">
        <div className="input-group">
          <div style={{ paddingBottom: "10px" }}>
            <label className="label">Class Name</label>
          </div>
          <select
            className="select-dropdown"
            value={classId}
            onChange={(e) => setClassId(e.target.value)}
            required
          >
            <option value="">-Select Class-</option>
            {schoolClassName &&
              schoolClassName.map((classes) => (
                <option value={classes._id} key={classes._id}>
                  {classes?.className}
                </option>
              ))}
          </select>
        </div>
        <button className="btn-s" type="submit">
          search
        </button>
      </form>

      <div className="classes-table-container">
        <h5>All Pricing</h5>
        <table className="classes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Class</th>
              <th>Price</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {/* Sample data rows */}

            {allSchoolPricing.map((data, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{data?.classId?.className}</td>
                <td>{data?.price}</td>
                <td className="table-action-icons">
                  <i
                    className="fa-solid fa-file-pen"
                    onClick={() => handleEdit(data._id)}
                  ></i>
                  &nbsp;&nbsp;
                  <i
                    className="fa-solid fa-trash-can"
                    onClick={() => handleDelete(data._id)}
                  ></i>
                </td>
              </tr>
            ))}

            {/* Add more rows as needed */}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllSchoolPricing;
